const config = [
  {
    path: '/register/:fromId/:fromType',
    name: 'register',
    component: () => import('../views/Register.vue'),
  },
  {
    path: '/success/:type',
    name: 'success',
    component: () => import('../views/Success.vue'),
  },
  {
    path: '/agreement/:type',
    name: 'agreement',
    component: () => import('../views/Agreement.vue'),
  },
];

export default config;
